import React, { useState, useEffect } from "react";
import Select from 'react-select';
import ImageShow from "../../Uitiles/ImageShow";

const PersonalDetails = ({
    formValues,
    handleInputChange,
    saving,
    loading,
    onProfilePhotoSelect,
    onProfilePhotoRemove,
    profilePhotoUploading,
    profilePhotoPreview,
}) => {
    const [selectedlanguages, setSelectedLanguages] = useState([]);
    const [errors, setErrors] = useState({});

    const languages = [
        { value: "217", label: "Afar" },
        { value: "216", label: "Abkhazian" },
        { value: "228", label: "Avestan" },
        { value: "219", label: "Afrikaans" },
        { value: "220", label: "Akan" },
        { value: "222", label: "Amharic" },
        { value: "224", label: "Aragonese" },
        { value: "223", label: "Arabic" },
        { value: "226", label: "Assamese" },
        { value: "227", label: "Avaric" },
        { value: "229", label: "Aymara" },
        { value: "230", label: "Azerbaijani" },
        { value: "232", label: "Bashkir" },
        { value: "234", label: "Belarusian" },
        { value: "240", label: "Bulgarian" },
        { value: "236", label: "Bihari languages" },
        { value: "237", label: "Bislama" },
        { value: "231", label: "Bambara" },
        { value: "235", label: "Bengali" },
        { value: "378", label: "Tibetan" },
        { value: "239", label: "Breton" },
        { value: "238", label: "Bosnian" },
        { value: "242", label: "Catalan, Valencian" },
        { value: "246", label: "Chechen" },
        { value: "245", label: "Chamorro" },
        { value: "252", label: "Corsican" },
        { value: "253", label: "Cree" },
        { value: "255", label: "Czech" },
        { value: "243", label: "Catalan, Catalunya" },
        { value: "249", label: "Church Slavonic, Old Bulgarian, Old Church Slavonic" },
        { value: "250", label: "Chuvash" },
        { value: "394", label: "Welsh" },
        { value: "256", label: "Danish" },
        { value: "273", label: "German" },
        { value: "257", label: "Divehi, Dhivehi, Maldivian" },
        { value: "259", label: "Dzongkha" },
        { value: "263", label: "Ewe" },
        { value: "275", label: "Greek (Modern)" },
        { value: "260", label: "English" },
        { value: "261", label: "Esperanto" },
        { value: "366", label: "Spanish, Castilian" },
        { value: "262", label: "Estonian" },
        { value: "233", label: "Basque" },
        { value: "346", label: "Persian" },
        { value: "268", label: "Fulah" },
        { value: "266", label: "Finnish" },
        { value: "265", label: "Fijian" },
        { value: "264", label: "Faroese" },
        { value: "267", label: "French" },
        { value: "395", label: "Western Frisian" },
        { value: "294", label: "Irish" },
        { value: "269", label: "Gaelic, Scottish Gaelic" },
        { value: "270", label: "Galician" },
        { value: "277", label: "Guarani" },
        { value: "278", label: "Gujarati" },
        { value: "322", label: "Manx" },
        { value: "280", label: "Hausa" },
        { value: "281", label: "Hebrew" },
        { value: "283", label: "Hindi" },
        { value: "284", label: "Hiri Motu" },
        { value: "254", label: "Croatian" },
        { value: "279", label: "Haitian, Haitian Creole" },
        { value: "285", label: "Hungarian" },
        { value: "225", label: "Armenian" },
        { value: "282", label: "Herero" },
        { value: "290", label: "Interlingua (International Auxiliary Language Association)" },
        { value: "289", label: "Indonesian" },
        { value: "291", label: "Interlingue" },
        { value: "288", label: "Igbo" },
        { value: "337", label: "Nuosu, Sichuan Yi" },
        { value: "293", label: "Inupiaq" },
        { value: "287", label: "Ido" },
        { value: "286", label: "Icelandic" },
        { value: "295", label: "Italian" },
        { value: "292", label: "Inuktitut" },
        { value: "296", label: "Japanese" },
        { value: "297", label: "Javanese" },
        { value: "272", label: "Georgian" },
        { value: "304", label: "Kongo" },
        { value: "274", label: "Gikuyu, Kikuyu" },
        { value: "306", label: "Kwanyama, Kuanyama" },
        { value: "301", label: "Kazakh" },
        { value: "276", label: "Greenlandic, Kalaallisut" },
        { value: "244", label: "Central Khmer" },
        { value: "298", label: "Kannada" },
        { value: "305", label: "Korean" },
        { value: "299", label: "Kanuri" },
        { value: "300", label: "Kashmiri" },
        { value: "307", label: "Kurdish" },
        { value: "303", label: "Komi" },
        { value: "251", label: "Cornish" },
        { value: "308", label: "Kyrgyz" },
        { value: "310", label: "Latin" },
        { value: "312", label: "Letzeburgesch, Luxembourgish" },
        { value: "271", label: "Ganda" },
        { value: "313", label: "Limburgish, Limburgan, Limburger" },
        { value: "314", label: "Lingala" },
        { value: "309", label: "Lao" },
        { value: "315", label: "Lithuanian" },
        { value: "316", label: "Luba-Katanga" },
        { value: "311", label: "Latvian" },
        { value: "318", label: "Malagasy" },
        { value: "325", label: "Marshallese" },
        { value: "323", label: "Maori" },
        { value: "317", label: "Macedonian" },
        { value: "320", label: "Malayalam" },
        { value: "327", label: "Mongolian" },
        { value: "324", label: "Marathi" },
        { value: "319", label: "Malay" },
        { value: "321", label: "Maltese" },
        { value: "241", label: "Burmese" },
        { value: "328", label: "Nauru" },
        { value: "335", label: "Norwegian Bokmål" },
        { value: "330", label: "Northern Ndebele" },
        { value: "332", label: "Nepali" },
        { value: "331", label: "Ndonga" },
        { value: "258", label: "Dutch, Flemish" },
        { value: "336", label: "Norwegian Nynorsk" },
        { value: "334", label: "Norwegian" },
        { value: "365", label: "South Ndebele" },
        { value: "329", label: "Navajo, Navaho" },
        { value: "247", label: "Chichewa, Chewa, Nyanja" },
        { value: "338", label: "Occitan (post 1500)" },
        { value: "339", label: "Ojibwa" },
        { value: "341", label: "Oromo" },
        { value: "340", label: "Oriya" },
        { value: "342", label: "Ossetian, Ossetic" },
        { value: "344", label: "Panjabi, Punjabi" },
        { value: "343", label: "Pali" },
        { value: "347", label: "Polish" },
        { value: "345", label: "Pashto, Pushto" },
        { value: "348", label: "Portuguese" },
        { value: "349", label: "Quechua" },
        { value: "350", label: "Romansh" },
        { value: "351", label: "Rundi" },
        { value: "326", label: "Moldovan, Moldavian, Romanian" },
        { value: "352", label: "Russian" },
        { value: "302", label: "Kinyarwanda" },
        { value: "355", label: "Sanskrit" },
        { value: "356", label: "Sardinian" },
        { value: "359", label: "Sindhi" },
        { value: "333", label: "Northern Sami" },
        { value: "354", label: "Sango" },
        { value: "360", label: "Sinhala, Sinhalese" },
        { value: "361", label: "Slovak" },
        { value: "362", label: "Slovenian" },
        { value: "353", label: "Samoan" },
        { value: "358", label: "Shona" },
        { value: "363", label: "Somali" },
        { value: "221", label: "Albanian" },
        { value: "357", label: "Serbian" },
        { value: "369", label: "Swati" },
        { value: "364", label: "Sotho, Southern" },
        { value: "367", label: "Sundanese" },
        { value: "370", label: "Swedish" },
        { value: "368", label: "Swahili" },
        { value: "374", label: "Tamil" },
        { value: "376", label: "Telugu" },
        { value: "373", label: "Tajik" },
        { value: "377", label: "Thai" },
        { value: "379", label: "Tigrinya" },
        { value: "384", label: "Turkmen" },
        { value: "371", label: "Tagalog" },
        { value: "382", label: "Tswana" },
        { value: "380", label: "Tonga (Tonga Islands)" },
        { value: "383", label: "Turkish" },
        { value: "381", label: "Tsonga" },
        { value: "375", label: "Tatar" },
        { value: "385", label: "Twi" },
        { value: "372", label: "Tahitian" },
        { value: "386", label: "Uighur, Uyghur" },
        { value: "387", label: "Ukrainian" },
        { value: "388", label: "Urdu" },
        { value: "389", label: "Uzbek" },
        { value: "390", label: "Venda" },
        { value: "391", label: "Vietnamese" },
        { value: "392", label: "Volap_k" },
        { value: "393", label: "Walloon" },
        { value: "396", label: "Wolof" },
        { value: "397", label: "Xhosa" },
        { value: "398", label: "Yiddish" },
        { value: "399", label: "Yoruba" },
        { value: "400", label: "Zhuang, Chuang" },
        { value: "248", label: "Chinese" },
        { value: "218", label: "Zulu" }
    ];

    useEffect(() => {
        if (formValues.languages?.length > 0 && !selectedlanguages.length) {
            const defaultSelected = languages.filter(option =>
                formValues.languages.includes(option.value)
            );
            setSelectedLanguages(defaultSelected);
        }
    }, [formValues.languages]);

    const validateField = (name, value) => {
        let error = '';
        switch (name) {
            case 'gendar':
                if (!value) error = 'Gender is required';
                break;
            case 'subheading':
                if (!value) error = 'Sub heading is required';
                break;
            case 'first_name':
                if (!value) error = 'First name is required';
                else if (!/^[a-zA-Z\s]{2,50}$/.test(value)) error = 'First name should only contain letters and spaces (2-50 characters)';
                break;
            case 'last_name':
                if (!value) error = 'Last name is required';
                else if (!/^[a-zA-Z\s]{2,50}$/.test(value)) error = 'Last name should only contain letters and spaces (2-50 characters)';
                break;
            case 'display_name':
                if (!value) error = 'Display name is required';
                else if (!/^[a-zA-Z0-9\s]{2,50}$/.test(value)) error = 'Display name should only contain letters, numbers, and spaces (2-50 characters)';
                break;
            case 'email':
                if (!value) error = 'Email is required';
                else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) error = 'Please enter a valid email address';
                break;
            case 'mobile_number':
                if (!value) error = 'Mobile number is required';
                else if (!/^\+?[1-9]\d{7,14}$/.test(value)) error = 'Please enter a valid international phone number';
                break;
            case 'description':
                if (!value) error = 'Description is required';
                break;
            case 'languages':
                if (!value || value.length === 0) error = 'At least one language is required';
                break;
            default:
                break;
        }
        return error;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const error = validateField(name, value);
        setErrors(prev => ({
            ...prev,
            [name]: error
        }));
        handleInputChange(e);
    };

    const handleLanguageChange = (selectedOptions) => {
        const updated = selectedOptions || [];
        setSelectedLanguages(updated);
        const error = validateField('languages', updated);
        setErrors(prev => ({
            ...prev,
            languages: error
        }));
        // Update formValues through a synthetic event
        const syntheticEvent = {
            target: {
                name: 'languages',
                value: updated.map(option => option.value)
            }
        };
        handleInputChange(syntheticEvent);
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file && typeof onProfilePhotoSelect === "function") {
            await onProfilePhotoSelect(file);
        }
        if (e.target) {
            e.target.value = "";
        }
    };

    const handleRemoveImage = () => {
        if (saving || profilePhotoUploading) {
            return;
        }
        if (typeof onProfilePhotoRemove === "function") {
            onProfilePhotoRemove();
        }
    };

    const showPreview = Boolean(profilePhotoPreview);
    const hasStoredPhoto = Boolean(formValues?.profile_photo_url);

    return (
        <div className="dc-tabscontent tab-content">
            {loading ? (
                <div className="text-center p-5">
                    <div className="spinner-border" role="status"></div>
                </div>
            ) : (
                <div className="dc-personalskillshold tab-pane active fade show" id="dc-skills">
                    <div className="dc-yourdetails dc-tabsinfo">
                        <div className="dc-tabscontenttitle">
                            <h3>Your Details</h3>
                        </div>
                        <div className="dc-formtheme dc-userform">
                            <fieldset>
                                <div className="form-group form-group-half">
                                    <span className="dc-select">
                                        <select
                                            name="gendar"
                                            onChange={handleChange}
                                            className={`form-control ${errors.gendar ? 'is-invalid' : ''}`}
                                            value={formValues.gendar || ""}
                                            disabled={saving}
                                            style={{ height: '50px' }}
                                        >
                                            <option value="">Select gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="all">Others</option>
                                        </select>
                                        {errors.gendar && <div className="invalid-feedback">{errors.gendar}</div>}
                                    </span>
                                </div>
                                <div className="form-group form-group-half toolip-wrapo">
                                    <input
                                        type="text"
                                        value={formValues.subheading || ""}
                                        name="subheading"
                                        className={`form-control ${errors.subheading ? 'is-invalid' : ''}`}
                                        placeholder="Sub Heading"
                                        onChange={handleChange}
                                        disabled={saving}
                                    />
                                    {errors.subheading && <div className="invalid-feedback">{errors.subheading}</div>}
                                </div>
                                <div className="form-group form-group-half toolip-wrapo">
                                    <input
                                        type="text"
                                        name="first_name"
                                        className={`form-control ${errors.first_name ? 'is-invalid' : ''}`}
                                        value={formValues.first_name || ""}
                                        placeholder="First name"
                                        onChange={handleChange}
                                        disabled={saving}
                                    />
                                    {errors.first_name && <div className="invalid-feedback">{errors.first_name}</div>}
                                </div>
                                <div className="form-group form-group-half toolip-wrapo">
                                    <input
                                        type="text"
                                        value={formValues.last_name || ""}
                                        onChange={handleChange}
                                        name="last_name"
                                        className={`form-control ${errors.last_name ? 'is-invalid' : ''}`}
                                        placeholder="Last Name"
                                        disabled={saving}
                                    />
                                    {errors.last_name && <div className="invalid-feedback">{errors.last_name}</div>}
                                </div>
                                <div className="form-group toolip-wrapo">
                                    <input
                                        type="text"
                                        name="display_name"
                                        className={`form-control ${errors.display_name ? 'is-invalid' : ''}`}
                                        value={formValues.display_name || ""}
                                        placeholder="Display name"
                                        onChange={handleChange}
                                        disabled={saving}
                                    />
                                    {errors.display_name && <div className="invalid-feedback">{errors.display_name}</div>}
                                </div>
                                <div className="form-group toolip-wrapo">
                                    <input
                                        type="email"
                                        name="email"
                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                        value={formValues.email || ""}
                                        placeholder="Email address"
                                        onChange={handleChange}
                                        disabled={saving}
                                    />
                                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                </div>
                                <div className="form-group toolip-wrapo">
                                    <input
                                        type="text"
                                        name="phone"
                                        className="form-control"
                                        value={formValues.phone || ""}
                                        placeholder="Phone number"
                                        onChange={handleChange}
                                        disabled={saving}
                                    />
                                </div>
                                <div className="form-group toolip-wrapo">
                                    <input
                                        type="text"
                                        name="mobile_number"
                                        className={`form-control ${errors.mobile_number ? 'is-invalid' : ''}`}
                                        value={formValues.mobile_number || ""}
                                        placeholder="Personal mobile number"
                                        onChange={handleChange}
                                        disabled={saving}
                                    />
                                    {errors.mobile_number && <div className="invalid-feedback">{errors.mobile_number}</div>}
                                </div>
                                <div className="form-group">
                                    <textarea
                                        name="description"
                                        value={formValues.description || ""}
                                        onChange={handleChange}
                                        className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                        placeholder="Description"
                                        disabled={saving}
                                    ></textarea>
                                    {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                                </div>
                                <div className="form-group">
                                    <textarea
                                        name="address"
                                        value={formValues.address || ""}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Address"
                                        disabled={saving}
                                    ></textarea>
                                </div>
                                <div className="form-group form-group-half">
                                    <input
                                        type="text"
                                        name="city"
                                        className="form-control"
                                        value={formValues.city || ""}
                                        placeholder="City"
                                        onChange={handleChange}
                                        disabled={saving}
                                    />
                                </div>
                                <div className="form-group form-group-half">
                                    <input
                                        type="text"
                                        name="state"
                                        className="form-control"
                                        value={formValues.state || ""}
                                        placeholder="State"
                                        onChange={handleChange}
                                        disabled={saving}
                                    />
                                </div>
                                <div className="form-group form-group-half">
                                    <input
                                        type="text"
                                        name="country"
                                        className="form-control"
                                        value={formValues.country || ""}
                                        placeholder="Country"
                                        onChange={handleChange}
                                        disabled={saving}
                                    />
                                </div>
                                <div className="form-group form-group-half">
                                    <input
                                        type="text"
                                        name="postal_code"
                                        className="form-control"
                                        value={formValues.postal_code || ""}
                                        placeholder="Postal code"
                                        onChange={handleChange}
                                        disabled={saving}
                                    />
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className="dc-tabsinfo">
                        <div className="dc-tabscontenttitle">
                            <h3>Select languages</h3>
                        </div>
                        <div className="dc-settingscontent dc-sidepadding">
                            <div className="dc-formtheme dc-userform">
                                <div className="form-group">
                                    <Select
                                        name="settings[languages][]"
                                        options={languages}
                                        placeholder="Select languages"
                                        className={`am_gender ${errors.languages ? 'is-invalid' : ''}`}
                                        isMulti
                                        value={selectedlanguages || []}
                                        onChange={handleLanguageChange}
                                        isSearchable
                                        isDisabled={saving}
                                    />
                                    {errors.languages && <div className="invalid-feedback">{errors.languages}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="dc-profilephoto dc-tabsinfo">
                        <div className="dc-tabscontenttitle">
                            <h3>Profile Photo</h3>
                        </div>
                        <div className="dc-profilephotocontent">
                            <div className="dc-formtheme dc-formprojectinfo dc-formcategory" id="dc-img-9880">
                                <fieldset>
                                    <div className="form-group form-group-label" id="dc-image-container-9880" style={{ position: 'relative' }}>
                                        <div className="dc-labelgroup" id="image-drag-9880" style={{ position: 'relative' }}>
                                            <label htmlFor="profile-photo" className="dc-image-file">
                                                <span className={`ajax-load dc-btn ${errors.profile_photo ? 'is-invalid' : ''}`} id="image-btn-9880">Select File</span>
                                            </label>
                                            <span>Drop files here to upload</span>
                                            {profilePhotoUploading && (
                                                <em className="dc-fileuploading">
                                                    Uploading<i className="fa fa-spinner fa-spin"></i>
                                                </em>
                                            )}
                                        </div>
                                        <div className="moxie-shim moxie-shim-html5" style={{ position: 'absolute', top: 7, left: 11, width: 160, height: 42, overflow: 'hidden', zIndex: 0 }}>
                                            <input
                                                id="profile-photo"
                                                type="file"
                                                style={{ fontSize: 999, opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                accept="image/jpeg,.jpg,.jpeg,image/gif,.gif,image/png,.png"
                                                onChange={handleFileChange}
                                                disabled={saving || profilePhotoUploading}
                                            />
                                        </div>
                                        {errors.profile_photo && <div className="invalid-feedback">{errors.profile_photo}</div>}
                                    </div>
                                    {(showPreview || hasStoredPhoto) && (
                                        <div className="form-group uploaded-placeholder">
                                            <ul className="dc-attachfile dc-attachfilevtwo">
                                                <li className="dc-uploadingholder dc-companyimg-user">
                                                    <div className="dc-uploadingbox">
                                                        <figure>
                                                            <ImageShow
                                                                url={showPreview ? profilePhotoPreview : formValues.profile_photo_url}
                                                                className="img-thumb"
                                                                width={100}
                                                                height={100}
                                                                style={{ borderRadius: '4px' }}
                                                            />
                                                        </figure>
                                                        <div className="dc-uploadingbar">
                                                            <span className="uploadprogressbar"></span>
                                                            <span>
                                                                {formValues.profile_photo_url
                                                                    ? (formValues.profile_photo_url.includes('/')
                                                                        ? formValues.profile_photo_url.split('/').pop()
                                                                        : formValues.profile_photo_url)
                                                                    : 'Profile Photo'}
                                                            </span>
                                                            <em>
                                                                <a
                                                                    href="#"
                                                                    className="dc-remove-image lnr lnr-cross"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleRemoveImage();
                                                                    }}
                                                                ></a>
                                                            </em>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PersonalDetails;
